import { X } from 'lucide-react';

export default function ModalShell({
  title,
  onClose,
  children,
  footer,
  maxWidth = '26.25rem',
  showClose = true,
  closeOnBackdrop = true,
  bodyClassName = 'p-6 flex flex-col gap-6',
}) {
  return (
    <div className='fixed inset-0 z-[1000] flex justify-center items-center'>
      <div
        className='absolute inset-0 bg-black/40 dark:bg-black/70 backdrop-blur-sm animate-fadein'
        onClick={closeOnBackdrop ? () => onClose?.() : undefined}
        aria-hidden='true'
      />
      <div
        className='relative w-full rounded-xl dark:border dark:border-[#3C3E53] bg-[#FFFFFF] dark:bg-[#242933] shadow-[58px_41px_42px_0_rgba(0,0,0,0.07),_6px_5px_17px_0_rgba(0,0,0,0.13)] dark:shadow-[-4px_0_4px_0_rgba(0,0,0,0.25)] animate-popup'
        style={{ maxWidth }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className='flex items-center justify-between gap-4 px-6 py-4 border-b border-b-[#E8E8EA] dark:border-b-[#3C3E53]'>
          <h3 className='text-xl font-semibold text-[#16192C] dark:text-[#FAFAFA]'>{title}</h3>
          {showClose && (
            <X
              className='size-5 text-[#8A8C95] hover:text-[#4B4B4B] dark:text-[#90A1B9] dark:hover:text-[#CAD5E2] cursor-pointer transition-all duration-300'
              onClick={() => onClose?.()}
            />
          )}
        </div>

        {bodyClassName ? <div className={bodyClassName}>{children}</div> : children}

        {footer ? <div className='px-6 pb-6 flex justify-end'>{footer}</div> : null}
      </div>
    </div>
  );
}
